import {Locale} from '@hebcal/hdate';
import poData from './ru.po.js';
Locale.addLocale('ru', poData);
